import * as Yup from "yup";
import { BoletagemJuridicoStatus } from "../boletagem";

export class BoletagemJuridicoSchema {
  public static updateForm() {
    const {
      juridicoStatus,
    } = recordShape;

    const updateFormShape = {
      juridicoStatus,
    };

    return Yup
      .object()
      .shape(updateFormShape);
  }
}

const recordShape = {
  juridicoStatus: Yup
    .mixed<BoletagemJuridicoStatus>().oneOf(Object.values(BoletagemJuridicoStatus), `Status Jurídico deve ser "${Object.values(BoletagemJuridicoStatus).join('" ou "')}"`),
};
